import angular from 'angular'
import commonTemplate from 'views/common/template.html'

const certificationInfoPage = require('./views/certificationList.html')
const certificationListCtrl = require('./certificationListCtrl')



export default angular
    .module('app.certification', [])
    .config([
        '$stateProvider',
        function config ($stateProvider) {
            $stateProvider
                .state('certification', {
                    abstract: true,
                    url: '/certification',
                    template: commonTemplate,
                    title: '实名认证',
                    default: 'certification.list',
                })
                .state('certification.list', {
                    url: '/list',
                    template: certificationInfoPage,
                    controller: 'certificationListCtrl',
                    title: '实名认证',
                })
        },
    ])
    .controller('certificationListCtrl', certificationListCtrl.default).name



// WEBPACK FOOTER //
// ./src/app/main/certification/index.js